/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('global/UrlHelper',[
    './Logger'
], function (Logger) {
    'use strict';

    /**
     * Builds url with Query String including given parameters
     * @param {string} url  - the base URL
     * @param {Object} params - the parameters to include in query string
     * @returns {} 
     */
    function buildUrlWithQueryString(url, params) {
        var newUrl = url;
        var queryString = '';
        for (var key in params) {
            if (!params.hasOwnProperty(key)) {
                continue;
            }

            var value = params[key];
            queryString += encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
        }

        if (queryString.length > 0) {
            queryString = queryString.substring(0, queryString.length - 1);
            newUrl += (newUrl.indexOf('?') > -1 ? '&' : '?') + queryString;
        }

        return newUrl;
    }

    /**
     * Returns decoded parameter from the query string
     * @param {string} name - the parameter name
     * @param {string} [url] - the url or undefined/null to use current location
     * @returns {} 
     */
    function getQueryStringParameterByName(name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    /**
     * 
     * @param {Object} params - the parameters to include in query string.
     * @returns {} 
     */
    function buildCurrentUrlWithQueryString(params) {
        return buildUrlWithQueryString(window.location.href, params);
    }

    /**
     * Build url with redirect action to another url.
     * @param {string} redirectTo - target url
     * @param {} redirectBack - back url
     * @returns {string} 
     */
    function buildRedirectUrl(redirectTo, redirectBack) {
        var redir = encodeURIComponent(redirectBack);
        return redirectTo + '?redir=' + redir;
    }

    var UrlHelper = {
        buildUrlWithQueryString: buildUrlWithQueryString,
        buildCurrentUrlWithQueryString: buildCurrentUrlWithQueryString,
        buildRedirectUrl: buildRedirectUrl,
        getQueryStringParameterByName: getQueryStringParameterByName
    };

    Logger.debug('UrlHelper.js Loaded:', UrlHelper);

    return UrlHelper;
});
